import React from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import Button from './atoms/Button';
import Input from './atoms/Input';

interface ScanResultCardProps {
  onValidate: (personId: string) => void;
}

const SearchByPersonId: React.FC<ScanResultCardProps> = ({ onValidate }) => {
  const form = useForm<{ personId: string }>({
    defaultValues: {
      personId: localStorage.getItem('personId') ?? '',
    },
  });

  const { handleSubmit, control } = form;

  const submit = (data: { personId: string }) => {
    onValidate(data.personId);
    localStorage.setItem('personId', data.personId);
  };

  return (
    <div className={'h-full p-6 w-full'}>
      <div className="flex justify-center mb-4">
        <div className={'bg-surface-secondary mt-10 rounded-full p-8'}>
          <IoSearchOutline className="w-20 h-20" />
        </div>
      </div>
      <h2 className={'text-center text-3xl font-medium mb-2'}>
        Validador de DNI
      </h2>
      <div>
        <p className="text-center text-lg text-text-secondary mb-2">
          Ingresá el numero de documento del asistente para poder validar su
          código.
        </p>
        <form onSubmit={handleSubmit(submit)} className="mt-24">
          <div className='relative'>
            <Controller
              name="personId"
              control={control}
              render={({ field }) => (
                <Input
                  label="DNI"
                  id="person_id"
                  labelAbove
                  type="number"
                  inputMode="numeric"
                  quickDelete
                  {...field}
                />
              )}
            />
          </div>
          <div className="flex flex-col justify-center my-10">
            <Button type="submit" className="mb-2 h-12 text-lg mt-10" variant="primary">
              Validar
            </Button>
            <Button type="button" variant="tertiary" onClick={() => onValidate('')}>
              Cancelar
            </Button>
          </div>
        </form>
        <div />
      </div>
    </div>
  );
};

export default SearchByPersonId;
